import { render, staticRenderFns } from "./hot-product.vue?vue&type=template&id=fe3d38fc&scoped=true"
import script from "./hot-product.vue?vue&type=script&lang=js"
export * from "./hot-product.vue?vue&type=script&lang=js"
import style0 from "./hot-product.vue?vue&type=style&index=0&id=fe3d38fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe3d38fc",
  null
  
)

export default component.exports